/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ConfigResponse } from '../models/config-response';
import { replaceOrganizationConfig } from '../fn/t-systems/replace-organization-config';
import { ReplaceOrganizationConfig$Params } from '../fn/t-systems/replace-organization-config';

@Injectable({ providedIn: 'root' })
export class TSystemsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `replaceOrganizationConfig()` */
  static readonly ReplaceOrganizationConfigPath = '/administration/organizations/{organizationKey}/config';

  /**
   * update organization specific configuration.
   *
   * Endpoint for T-Systems Frontend (breaking changes at any times possible).Allows the organization admin to update organization specific configuration. For example confirm registration.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `replaceOrganizationConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceOrganizationConfig$Response(params: ReplaceOrganizationConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfigResponse>> {
    const obs = replaceOrganizationConfig(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * update organization specific configuration.
   *
   * Endpoint for T-Systems Frontend (breaking changes at any times possible).Allows the organization admin to update organization specific configuration. For example confirm registration.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `replaceOrganizationConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceOrganizationConfig(params: ReplaceOrganizationConfig$Params, context?: HttpContext): Observable<ConfigResponse> {
    const resp = this.replaceOrganizationConfig$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConfigResponse>): ConfigResponse => r.body)
    );
  }

}
